export const BgColor = [
  { value: "st-nicolas-01", type: "image" },
  { value: "st-nicolas-02", type: "image" },
  { value: "st-nicolas-03", type: "image" },
  { value: "fete-01", type: "image" },
  { value: "ete-01", type: "image" },
  { value: "ete-02", type: "image" },
  { value: "ete-03", type: "image" },
  { value: "amour-01", type: "image" },
  { value: "amour-02", type: "image" },
  { value: "amour-03", type: "image" },
  { value: "amour-04", type: "image" },
  { value: "amour-05", type: "image" },
  { value: "bariole-01", type: "image" },
  { value: "bariole-02", type: "image" },
  { value: "automne-01", type: "image" },
  { value: "#ffffff", type: "color" }, // blanc
  { value: "#80d8ff", type: "color" }, // bleu ciel
  { value: "#0066c0", type: "color" }, // bleu
  { value: "#ccff90", type: "color" }, // vert clair
  { value: "#ffff8d", type: "color" }, // jaune pastel
  { value: "#fee600", type: "color" }, // jaune petant
  { value: "#d2b800", type: "color" }, // dorée
  { value: "#63502e", type: "color" }, // marron
  { value: "#ffab91", type: "color" }, // beige ?
  { value: "#ff6f67", type: "color" }, // rose
  { value: "#c4000b", type: "color" }, // rouge
  { value: "#7a1420", type: "color" }, // rouge marron
  { value: "#e1bee7", type: "color" }, // violet blanc
  { value: "#633c91", type: "color" }, // violet
  { value: "#bfebff", type: "color" }, // bleu ciel clair
  { value: "#e6ffc8", type: "color" }, // vert ciel clair
  { value: "#f0dff3", type: "color" }, // violet ciel clair
  { value: "#212121", type: "color" }, // noir 80%
  { value: "#9e9e9e", type: "color" }, // gris
  { value: "#e0e0e0", type: "color" }, // gris clair
  { value: "to bottom, #ffffff, #b19dc8", type: "gradient" }, // gradient blanc to violet
  { value: "to bottom, #ffffff, #e17f85", type: "gradient" }, // gradient blanc to violet
  { value: "to bottom, #ffffff, #7fb2df", type: "gradient" }, // gradient blanc to violet
  { value: "to bottom, #ffffff, #ffffc6", type: "gradient" }, // gradient blanc to violet
  { value: "to bottom, #ffffff, #ffd5c8", type: "gradient" }, // gradient blanc to violet
];

export const TextFont = [
  { key: "alegreya", family: "'Alegreya SC', serif", ggFont: "Alegreya+SC" },
  { key: "alegreyasans", family: "'Alegreya Sans SC', serif", ggFont: "Alegreya+Sans+SC" },
  { key: "amatic", family: "'Amatic SC', serif", ggFont: "Amatic+SC" },
  { key: "architects", family: "'Architects Daughter', cursive", ggFont: "Architects+Daughter" },
  { key: "badscript", family: "'Bad Script', cursive", ggFont: "Bad+Script" },
  { key: "caveat", family: "'Caveat', cursive", ggFont: "Caveat" },
  { key: "clickerscript", family: "'Clicker Script', cursive", ggFont: "Clicker+Script" },
  { key: "cormorant", family: "'Cormorant SC', serif", ggFont: "Cormorant+SC" },
  { key: "dancingScript", family: "'Dancing Script', cursive", ggFont: "Dancing+Script" },
  { key: "dr-sugiyama", family: "'Dr Sugiyama', cursive", ggFont: "Dr+Sugiyama" },
  { key: "gloria", family: "'Gloria Hallelujah', cursive", ggFont: "Gloria+Hallelujah" },
  { key: "grand-hotel", family: "'Grand Hotel', cursive", ggFont: "Grand+Hotel" },
  { key: "indie", family: "'Indie Flower', cursive", ggFont: "Indie+Flower" },
  { key: "josefin-sans", family: "'Josefin Sans', sans-serif", ggFont: "Josefin+Sans" },
  { key: "lily-script-one", family: "'Lily Script One', cursive", ggFont: "Lily+Script+One" },
  { key: "marker", family: "'Permanent Marker', cursive", ggFont: "Permanent+Marker" },
  { key: "pacifico", family: "'Pacifico', cursive", ggFont: "Pacifico" },
  { key: "patrick", family: "'Patrick Hand SC', cursive", ggFont: "Patrick+Hand+SC" },
  { key: "playfair", family: "'Playfair Display SC', serif", ggFont: "Playfair+Display+SC" },
  { key: "reenie-beanie", family: "'Reenie Beanie', cursive", ggFont: "Reenie+Beanie" },
  { key: "righteous", family: "'Righteous', sans-serif", ggFont: "Righteous" },
  { key: "robotoslab", family: "'Roboto Slab', serif", ggFont: "Roboto+Slab:wght@200" },
  { key: "satisfy", family: "'Satisfy', cursive", ggFont: "Satisfy" },
  { key: "seaweed-script", family: "'Seaweed Script', cursive", ggFont: "Seaweed+Script" },
  { key: "shadows-into-light", family: "'Shadows Into Light', cursive", ggFont: "Shadows+Into+Light" },
  { key: "vibes", family: "'Vibes', cursive", ggFont: "Vibes" },
];

export const TextColor = [
  { value: "#ffffff", type: "color" }, // blanc
  { value: "#80d8ff", type: "color" }, // bleu ciel
  { value: "#0066c0", type: "color" }, // bleu
  { value: "#ccff90", type: "color" }, // vert clair
  { value: "#ffff8d", type: "color" }, // jaune pastel
  { value: "#fee600", type: "color" }, // jaune petant
  { value: "#d2b800", type: "color" }, // dorée
  { value: "#63502e", type: "color" }, // marron
  { value: "#ffab91", type: "color" }, // beige ?
  { value: "#ff6f67", type: "color" }, // rose
  { value: "#c4000b", type: "color" }, // rouge
  { value: "#7a1420", type: "color" }, // rouge marron
  { value: "#e1bee7", type: "color" }, // violet blanc
  { value: "#633c91", type: "color" }, // violet
  { value: "#bfebff", type: "color" }, // bleu ciel clair
  { value: "#e6ffc8", type: "color" }, // vert ciel clair
  { value: "#f0dff3", type: "color" }, // violet ciel clair
  { value: "#000000", type: "color" }, // noir 100%
  { value: "#212121", type: "color" }, // noir 80%
  { value: "#9e9e9e", type: "color" }, // gris
  { value: "#e0e0e0", type: "color" }, // gris clair
];

export const TextSize = [
  { key: "16" },
  { key: "18" },
  { key: "20" },
  { key: "25" },
  { key: "30" },
  { key: "35" },
  { key: "40" },
  { key: "45" },
  { key: "50" },
  { key: "55" },
  { key: "60" },
];
